// extracted by mini-css-extract-plugin
export default {"upload":"s7Hex","uploadWithValue":"px9K5","icon":"Qi6No","text":"d5iDu","actionOverlay":"gGMjK","action":"ZUzbB","uploadReadOnly":"Hmmcc","inner":"XOkDF","preview":"iW1M6"};